var map = {
	"./frontend/AndroidGuide.vue": 7881,
	"./frontend/BetslipHistory.vue": 346,
	"./frontend/BodyFB.vue": 998,
	"./frontend/ContactUs.vue": 5571,
	"./frontend/DataTable.vue": 6107,
	"./frontend/Deposit.vue": 8776,
	"./frontend/History.vue": 7920,
	"./frontend/Home.vue": 983,
	"./frontend/IOSGuide.vue": 7508,
	"./frontend/Iframe.vue": 2251,
	"./frontend/Index.vue": 5778,
	"./frontend/Live.vue": 6130,
	"./frontend/MainMenu.vue": 7294,
	"./frontend/MaungFB.vue": 6709,
	"./frontend/Promotion.vue": 7512,
	"./frontend/Setting.vue": 7810,
	"./frontend/VideoLink.vue": 981,
	"./frontend/Withdraw.vue": 8499,
	"./frontend/auth/Login.vue": 7863,
	"./frontend/auth/Rule.vue": 4557,
	"./frontend/components/AccountSelect.vue": 3678,
	"./frontend/components/DataTable.vue": 4579,
	"./frontend/components/FBPreviewVoucher.vue": 630,
	"./frontend/components/FBVoucher.vue": 6329,
	"./frontend/components/FootballTeamCard.vue": 6924,
	"./frontend/components/GroupBox.vue": 7317,
	"./frontend/components/InputSelectDrawModal.vue": 1633,
	"./frontend/components/LuckyWheel.vue": 187,
	"./frontend/components/NormalBox.vue": 3540,
	"./frontend/components/PreviewVoucher.vue": 9003,
	"./frontend/components/SideNav.vue": 850,
	"./frontend/components/Table.vue": 5065,
	"./frontend/components/ThreedGroupBox.vue": 5959,
	"./frontend/components/ThreedQuickGroupBox.vue": 1057,
	"./frontend/components/TwoDSelect.vue": 8815,
	"./frontend/components/Voucher.vue": 4811,
	"./frontend/normal-user/2d/2d.vue": 2829,
	"./frontend/normal-user/2d/ClosedDays.vue": 3308,
	"./frontend/normal-user/2d/Home.vue": 5799,
	"./frontend/normal-user/2d/Winner.vue": 7580,
	"./frontend/normal-user/3d/3d.vue": 3822,
	"./frontend/normal-user/3d/Home.vue": 6470,
	"./frontend/normal-user/DreamBooks.vue": 2636,
	"./frontend/normal-user/Index.vue": 6012,
	"./frontend/normal-user/bugyee/Room.vue": 7576,
	"./frontend/normal-user/game/Buffalo.vue": 6685,
	"./frontend/normal-user/game/Fishing.vue": 9757,
	"./frontend/normal-user/game/Game.vue": 1217,
	"./frontend/normal-user/game/Slot.vue": 4399,
	"./frontend/normal-user/shankomee/Room.vue": 703
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;